import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';


// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class PaymentRequestScheduleDistanceIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      payment_legs: [],
      modal: false,
    };
    
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.openModal = this.openModal.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/escala/deslocamento/solicitacao', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  openModal(payment_id) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/deslocamento/solicitacao/trechos/' + payment_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({payment_legs: responseJson.data, modal: true});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var botao = '';
    if(row.request_status === 'Aberta') {
      botao = (
        <div className="btn-group">
          <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
            <i className="fa fa-fw fa-trash"></i>
          </button>
          <button className="btn btn-sm btn-info" value={cell} onClick={() => this.openModal(cell)}>
            <i className="fa fa-fw fa-eye"></i>
          </button>
        </div>
      );
    } else {
      botao = (
        <div className="btn-group">
          <button className="btn btn-sm btn-info" value={cell} onClick={() => this.openModal(cell)}>
            <i className="fa fa-fw fa-eye"></i>
          </button>
        </div>
      );
    }

    return botao;
  }

  delete (event) {
    var fatigue_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/pagamento/escala/deslocamento/solicitacao/' + fatigue_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(fatigue_id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRow(fatigue_id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == fatigue_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }

  render() {
    var self = this
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.titulo}</h3>
      <Link to="/cadastrar/solicitacao/pagamento/deslocamento/missao" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> {this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.botaoSolicitarPagamentoDeDeslocamentoMissao}</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.semSolicitacaoDePagamento}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="request_status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Status}</TableHeaderColumn>
        <TableHeaderColumn dataField="payment_batch" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Lote}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Frota}</TableHeaderColumn>
        <TableHeaderColumn dataField="schedule_month" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Mes}</TableHeaderColumn>
        <TableHeaderColumn dataField="schedule_grade_revision" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Revisao}</TableHeaderColumn>
        <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Inicio}</TableHeaderColumn>
        <TableHeaderColumn dataField="date_finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Fim}</TableHeaderColumn>
        <TableHeaderColumn dataField="daily_paid" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Quantidade}</TableHeaderColumn>
        <TableHeaderColumn dataField="daily_value" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Valor}</TableHeaderColumn>
        <TableHeaderColumn dataField="daily_total_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.ValorTotal}</TableHeaderColumn>
        <TableHeaderColumn dataField="daily_currency" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Moeda}</TableHeaderColumn>
        <TableHeaderColumn dataField="observation" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Observacao}</TableHeaderColumn>
        
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Ações}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
  <Modal show={this.state.modal} bsSize={'large'} aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tituloBases}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, payment_legs: [] })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div className="table-responsive">
        <table className="table table-bordered table-stripped table-hover">
          <thead>
            <tr>
              <th className="text-center">{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabelaBases.Origem}</th>
              <th className="text-center">{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabelaBases.CEPOrigem}</th>
              <th className="text-center">{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabelaBases.Destino}</th>
              <th className="text-center">{this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabelaBases.CEPDestino}</th>
            </tr>
          </thead>
          <tbody id="suppliers-certifications">
            {Object.keys(this.state.payment_legs).map(function(k) {
              return (
                <tr>
                  <td className="text-center">{self.state.payment_legs[k]['origin']}</td>
                  <td className="text-center">{self.state.payment_legs[k]['zipcode_origin']}</td>
                  <td className="text-center">{self.state.payment_legs[k]['destination']}</td>
                  <td className="text-center">{self.state.payment_legs[k]['zipcode_destination']}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, payment_legs: [] })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>

</div>
    );
  }
}

export default PaymentRequestScheduleDistanceIndex;



// WEBPACK FOOTER //
// ./src/Components/Payments/PaymentRequestScheduleDistanceIndex.js